var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout", [
    _c("div", { staticClass: "news news--archive pb-5" }, [
      _c("section", { staticClass: "container-fluid pb-sm-5" }, [
        _c("h1", { staticClass: "page-title" }, [
          _vm._v(_vm._s(this.settings.news.title)),
        ]),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "container-fluid pb-0" }, [
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(_vm.listNews, function (news, index) {
            return _c(
              "transition",
              { key: index, attrs: { name: "fade-news" } },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showUntil > index,
                        expression: "showUntil > index",
                      },
                    ],
                    staticClass: "col-sm-12 col-md-4 col-lg-3 col-xl-3 pb-4",
                  },
                  [_c("news-card", { attrs: { news: news } })],
                  1
                ),
              ]
            )
          }),
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid d-flex pt-0" }, [
        _vm.hasMore
          ? _c(
              "a",
              {
                staticClass: "nav-link border-link",
                attrs: { href: "" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.loadPage.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Ver mais")]
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }